module.exports = __webpack_public_path__ + "static/img/yunying.1d84343.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yunying.gif
// module id = uLNx
// module chunks = 1